export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";